import Vue from 'vue';
import store from './../../store';
import transTransformer from './../../transformers/productTransactionV2';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transactionsV2 = transTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
   // store.dispatch('fetchAllProductTransactionsV2', transactionsV2);
  store.dispatch('fetchProductTransactionsV2', { transactionsV2, pagination });
  resolve(transactionsV2);
};

const failed = (error, reject) => reject();


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`products/${options.id}/transactionsV2`, options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/transactionsV2.js